import React, { forwardRef, useEffect, useState } from 'react';

import { Input } from '@vlabs/uikit/components/controls/input';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import st from './popovers.module.sass';
import { useUserFiltersTranslation } from '../i18n';
import { useUserListFilters } from '../useUserListPageFilters';

function UserNameFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useUserFiltersTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useUserListFilters();

  const onChangeHandler = (userName: string) => {
    setLocalValue(userName);
    updateFiltersDebounced({ full_name: userName });
  };

  useEffect(() => {
    setLocalValue(filters?.full_name ?? '');
  }, [filters.full_name]);

  const reset = () => {
    updateFilters({ full_name: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      data-testid="full_name"
      onClickReset={reset}
      ref={ref}
      title={<div className={st.PopoverTitle}>{t('full_name.label')}</div>}
    >
      <Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const UserNameFilterPopoverWithRef = forwardRef(UserNameFilterPopover);
export { UserNameFilterPopoverWithRef as UserNameFilterPopover };
